<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.582"
    height="20.643"
    viewBox="0 0 24.582 20.643"
  >
    <g transform="translate(-1033.558 -580.746)">
      <rect
        width="1"
        height="2.229"
        transform="translate(1039.916 585.285)"
      />
      <path
        d="M1037.181,589.132l-1.57-1.574.707-.707,1.57,1.574Z"
      />
      <rect
        width="2.623"
        height="1"
        transform="translate(1033.558 591.25)"
      />
      <rect
        width="2.161"
        height="1"
        transform="matrix(0.715, -0.699, 0.699, 0.715, 1035.518, 595.864)"
      />
      <g>
        <circle
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(1037.534 588.631)"
          fill="none"
        />
        <path
                    d="M1041.034,595.631a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,1041.034,595.631Zm0-6a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,1041.034,589.631Z"
        />
      </g>
      <rect
        width="1"
        height="2.063"
        transform="translate(1039.916 596.222)"
      />
      <rect
        width="12.162"
        height="1"
        transform="translate(1045.978 594.771)"
      />
      <rect
        width="1"
        height="12.228"
        transform="translate(1051.559 589.161)"
      />
      <path
        d="M1054.1,600.308l-1.994-1.348-1.865,1.34-.584-.812,2.432-1.746,2.572,1.738Z"
      />
      <path
        d="M1047.873,597.847l-.82-.572,1.383-1.984-1.384-2,.822-.57,1.778,2.568Z"
      />
      <path
        d="M1056.261,597.836l-1.638-2.48,1.63-2.63.85.527-1.292,2.085,1.284,1.947Z"
      />
      <path
        d="M1051.913,592.645l-2.244-1.486.553-.834,1.74,1.152,2.135-1.174.482.877Z"
      />
      <path
        d="M1051.9,588.026c-.945,0-1.894-.01-1.957-.011h-3.267c-.086,0-2.466.069-3.043-1.913a2.169,2.169,0,0,1,.31-2.035,3.193,3.193,0,0,1,2.476-1.029,3.13,3.13,0,0,1,1.374-1.639,4.821,4.821,0,0,1,3.546-.514,2.574,2.574,0,0,1,1.677,2.1,5.8,5.8,0,0,1,2.381.287,1.952,1.952,0,0,1,1.04,1.321,2.78,2.78,0,0,1-.3,2.112,3.53,3.53,0,0,1-2.883,1.316C1052.889,588.023,1052.4,588.026,1051.9,588.026Zm-5.242-1.012h3.294s2.206.026,3.31,0a2.475,2.475,0,0,0,2.077-.917,1.819,1.819,0,0,0,.128-1.264.964.964,0,0,0-.457-.648,4.846,4.846,0,0,0-2.333-.155.5.5,0,0,1-.588-.47c0-.014-.078-1.446-1.025-1.716a3.851,3.851,0,0,0-2.753.409,2.084,2.084,0,0,0-1.025,1.387.5.5,0,0,1-.51.4,2.487,2.487,0,0,0-2.046.644,1.215,1.215,0,0,0-.136,1.138C1044.95,587.051,1046.589,587.014,1046.657,587.014Z"
      />
    </g>
  </svg>
</template>
